export const DIAGNOSIS_STEP_TYPES = {
    user_primary_goal: 'user_primary_goal', // 今いちばん変えたいのはどれですか？
    target_timeframe: 'target_timeframe', // いつ頃までに変化を感じたいですか？
    current_priority: 'current_priority', // 今のあなたの優先順位に一番近いのは？
    lifestyle_type: 'lifestyle_type', // 普段の生活で近いものを選んでください
    weekday_available_time: 'weekday_available_time', // 平日、運動やストレッチに使える時間はどれくらいですか？
    habits: 'habits', // 当てはまるものを選んでください
    lunch_habit: 'lunch_habit', // 昼食はどれに近いですか？
    meals_per_day: 'meals_per_day', // 普段の食事回数は？
    snack_timing: 'snack_timing', // 間食したくなるのはいつが多いですか？
    alcohol_frequency: 'alcohol_frequency', // お酒を飲む頻度は？
    appetite_trigger: 'appetite_trigger', // 食欲が乱れやすいのはどんな時ですか？
    last_weight_loss_timeframe: 'last_weight_loss_timeframe', // 最後に「少し痩せた」と感じたのはいつですか？
    past_diet_types: 'past_diet_types', // 過去に試したことがあるものは？
    motivation_trend: 'motivation_trend', // 時間が経つとモチベーションはどうなりがちですか？
    current_motivation_level: 'current_motivation_level', // 今のあなたのモチベーションは？（直感でOK）
    continuation_concerns: 'continuation_concerns', // 続ける上で不安なことは？（複数可）
    desired_outcomes: 'desired_outcomes', // 理想に近づいたら、あなたはどうなっていたいですか？（複数可）
    ideal_outcome: 'ideal_outcome', // 実現したいことは？
    desired_emotion: 'desired_emotion', // どんな気持ちを一番実感したいですか？
};
const buildChoices = (labels) => labels.map((label) => ({
    label,
    iconSrc: '',
}));
const buildChoicesWithIcons = (items) => items.map((item) => ({
    label: item.label,
    iconSrc: item.iconSrc,
}));
const buildStep = (params) => ({
    stepType: params.stepType,
    title: params.title,
    isMultipleChoice: params.isMultipleChoice,
    choices: buildChoices(params.choices),
});
export const MatchingAssessmentDiagnosisInfoStepVariant = {
    noRightAnswer: 'noRightAnswer',
    lifestyle: 'lifestyle',
    shortExercise: 'shortExercise',
    selfAcceptance: 'selfAcceptance',
    keepGoing: 'keepGoing',
    progressMakesChange: 'progressMakesChange',
    habitMatters: 'habitMatters',
    supportedEnvironment: 'supportedEnvironment',
    readyToStart: 'readyToStart',
    finalCheck: 'finalCheck',
};
const info = (variant) => ({
    type: 'info',
    variant,
});
const step = (data) => ({
    type: 'step',
    step: data,
});
export const matchingAssessmentDiagnosisFlow = [
    info(MatchingAssessmentDiagnosisInfoStepVariant.noRightAnswer),
    step(buildStep({
        stepType: DIAGNOSIS_STEP_TYPES.user_primary_goal,
        title: '今いちばん変えたいのはどれですか？',
        isMultipleChoice: false,
        choices: [
            '体重を落としたい',
            'お腹・見た目を変えたい',
            '間食や食欲をコントロールしたい',
            '体力・疲れやすさを改善したい',
            '健康診断の数値が気になる',
        ],
    })),
    step(buildStep({
        stepType: DIAGNOSIS_STEP_TYPES.target_timeframe,
        title: 'いつ頃までに変化を感じたいですか？',
        isMultipleChoice: false,
        choices: ['2週間後', '1ヶ月後', '3ヶ月後', '半年後', 'いつでもいい'],
    })),
    info(MatchingAssessmentDiagnosisInfoStepVariant.lifestyle),
    step({
        stepType: DIAGNOSIS_STEP_TYPES.lifestyle_type,
        title: '普段の生活で近いものを選んでください',
        isMultipleChoice: false,
        choices: buildChoicesWithIcons([
            { label: '日々座って過ごすことが多い', iconSrc: '/assets/images/goal_matching_assessments/sitting.png' },
            { label: 'できるだけ動くようにしている', iconSrc: '/assets/images/goal_matching_assessments/exercise.png' },
            { label: '1日中よく動き回っている', iconSrc: '/assets/images/goal_matching_assessments/walking.png' },
            { label: 'その日によってバラバラ', iconSrc: '/assets/images/goal_matching_assessments/calendar.png' },
        ]),
    }),
    info(MatchingAssessmentDiagnosisInfoStepVariant.shortExercise),
    step(buildStep({
        stepType: DIAGNOSIS_STEP_TYPES.habits,
        title: '当てはまるものを選んでください',
        isMultipleChoice: true,
        choices: [
            '食べる時間がバラバラ',
            '夜に食欲が暴走しやすい',
            '間食が多い',
            '外食・コンビニが多い',
            '早食いになりやすい',
            '食事中にスマホを見がち',
            '食べる量は少ないのに痩せない',
            '特にない',
        ],
    })),
    step(buildStep({
        stepType: DIAGNOSIS_STEP_TYPES.lunch_habit,
        title: '昼食はどれに近いですか？',
        isMultipleChoice: false,
        choices: ['コンビニ・外食が多い', '家で食べることが多い', '食べたり食べなかったり', '日によって違う'],
    })),
    step(buildStep({
        stepType: DIAGNOSIS_STEP_TYPES.meals_per_day,
        title: '普段の食事回数は？',
        isMultipleChoice: false,
        choices: ['1〜2回', '3回', '4回以上', 'バラバラ'],
    })),
    step(buildStep({
        stepType: DIAGNOSIS_STEP_TYPES.snack_timing,
        title: '間食したくなるのはいつが多いですか？',
        isMultipleChoice: false,
        choices: ['午前中', '午後', '夕方〜夜', '寝る前', 'あまりしない'],
    })),
    step(buildStep({
        stepType: DIAGNOSIS_STEP_TYPES.alcohol_frequency,
        title: 'お酒を飲む頻度は？',
        isMultipleChoice: false,
        choices: ['ほぼ飲まない', '週1〜2回', '週3〜4回', 'ほぼ毎日'],
    })),
    step(buildStep({
        stepType: DIAGNOSIS_STEP_TYPES.appetite_trigger,
        title: '食欲が乱れやすいのはどんな時ですか？',
        isMultipleChoice: true,
        choices: [
            'ストレスが強い時',
            '疲れている時',
            '夜遅い時間',
            '習慣で食べてしまう',
            '我慢すると反動がくる',
            '特にない',
        ],
    })),
    info(MatchingAssessmentDiagnosisInfoStepVariant.selfAcceptance),
    step(buildStep({
        stepType: DIAGNOSIS_STEP_TYPES.last_weight_loss_timeframe,
        title: '最後に「少し痩せた」と感じたのはいつですか？',
        isMultipleChoice: false,
        choices: ['ここ1ヶ月', '3ヶ月以内', '半年以内', '1年以上前', '思い出せない'],
    })),
    step(buildStep({
        stepType: DIAGNOSIS_STEP_TYPES.past_diet_types,
        title: '過去に試したことがあるものは？',
        isMultipleChoice: true,
        choices: [
            '糖質制限',
            '断食・ファスティング',
            'カロリー制限',
            'ジム・筋トレ',
            '有酸素中心',
            'アプリ・記録',
            'サプリ・置き換え',
            '特にない',
        ],
    })),
    info(MatchingAssessmentDiagnosisInfoStepVariant.keepGoing),
    step(buildStep({
        stepType: DIAGNOSIS_STEP_TYPES.motivation_trend,
        title: '時間が経つとモチベーションはどうなりがちですか？',
        isMultipleChoice: false,
        choices: ['下がっていく', '波がある', 'あまり変わらない', 'わからない'],
    })),
    step(buildStep({
        stepType: DIAGNOSIS_STEP_TYPES.current_motivation_level,
        title: '今のあなたのモチベーションは？（直感でOK）',
        isMultipleChoice: false,
        choices: ['1', '2', '3', '4', '5'],
    })),
    step(buildStep({
        stepType: DIAGNOSIS_STEP_TYPES.continuation_concerns,
        title: '続ける上で不安なことは？（複数可）',
        isMultipleChoice: true,
        choices: [
            '時間が取れない',
            '食事管理が苦手',
            'すぐ挫折する',
            'リバウンドが怖い',
            '体力がない',
            '何をしたらいいかわからない',
            '特にない',
        ],
    })),
    info(MatchingAssessmentDiagnosisInfoStepVariant.progressMakesChange),
    step(buildStep({
        stepType: DIAGNOSIS_STEP_TYPES.desired_outcomes,
        title: '理想に近づいたら、あなたはどうなっていたいですか？（複数可）',
        isMultipleChoice: true,
        choices: [
            '自信を取り戻したい',
            '服を楽しみたい',
            '疲れにくくなりたい',
            '健康診断を改善したい',
            'ストレスを減らしたい',
            'その他',
        ],
    })),
    info(MatchingAssessmentDiagnosisInfoStepVariant.habitMatters),
    step(buildStep({
        stepType: DIAGNOSIS_STEP_TYPES.ideal_outcome,
        title: '実現したいことは？',
        isMultipleChoice: false,
        choices: ['続けられる習慣を作りたい', '食欲の暴走を止めたい', '体型の悩みを解消したい', '体力と集中力を上げたい'],
    })),
    step(buildStep({
        stepType: DIAGNOSIS_STEP_TYPES.desired_emotion,
        title: 'どんな気持ちを一番実感したいですか？',
        isMultipleChoice: false,
        choices: ['変われる確信', '安心感', '達成感', '自信'],
    })),
    info(MatchingAssessmentDiagnosisInfoStepVariant.supportedEnvironment),
    info(MatchingAssessmentDiagnosisInfoStepVariant.readyToStart),
    info(MatchingAssessmentDiagnosisInfoStepVariant.finalCheck),
];
